"use client";

import { EmptyState } from "@/components/shared/empty-state";

import { useDiscoverContext } from "./discover-context";
import {
  DiscoverCreatorItem,
  DiscoverCreatorItemErrorBoundary,
} from "./discover-creator-item";
import { DiscoverHeader } from "./discover-header";
import { DiscoverTopFilters } from "./discover-top-filters";

export const DiscoverLayout = () => {
  const {
    creators,
    lazyLoadingMarkup,
    loading,
    findFilterByName,
    initialLoading,
    filterBlockedAccount,
  } = useDiscoverContext();

  return (
    <>
      <DiscoverTopFilters />
      <DiscoverHeader />
      <div className="relative">
        {creators.map((creator) => (
          <DiscoverCreatorItemErrorBoundary key={creator.publicKeyBase58Check}>
            <div className="m-4 rounded-2xl border border-border">
              <DiscoverCreatorItem
                user={creator}
                {...{
                  filterBlockedAccount,
                  findFilterByName,
                }}
                hasBorder={false}
              />
            </div>
          </DiscoverCreatorItemErrorBoundary>
        ))}
        {lazyLoadingMarkup}
        {!loading && !initialLoading && !creators.length && (
          <div className="py-24">
            <EmptyState
              image="/assets/empty-15.png"
              title="We couldn't find any creators."
              description="You might want to adjust your filters."
            />
          </div>
        )}
      </div>
    </>
  );
};
